import withStyles from 'react-jss';
import { SmileOutlined } from '@ant-design/icons';

const styles = {
    main: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    message1: {
        textAlign: 'center',
        color: '#007468',
        fontSize: '1.0rem',
        fontFamily: 'Roboto, sans-serif',
    },
    message2: {
        marginTop: '2%',
        textAlign: 'center',
        color: '#4a4a4a',
        fontSize: '1.0rem',
        fontFamily: 'Roboto, sans-serif',
    },
};

const SuccessPage = (props: any) => {
    const { classes, message } = props;
    return (
        <div className={classes.main}>
            <div style={{ width: '100%', textAlign: 'center', marginTop: '20%', fontSize: '100px' }}>
                <SmileOutlined />
            </div>
            <div className={classes.message2}>
                {message}
            </div>
        </div>
    );
};

const NotFound404 = withStyles(styles)(SuccessPage);
export default NotFound404;
